export const CW_PAYMENT_REGEX = /^(saferpaycw|datatranscw)/;
export const CW_PAYMENT_CODE = 'cw_payment';
export const RESTORE_CART_STEP = 'RESTORE_CART_STEP';